import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-6 h-6 primary-text",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M14 6c0-2.206-1.794-4-4-4S6 3.794 6 6s1.794 4 4 4 4-1.794 4-4m6 14h-5v-2h2.784c-.826-3.786-3.999-6-7.784-6s-6.958 2.214-7.784 6H5v2H0c0-4.555 2.583-7.952 6.242-9.327A5.98 5.98 0 0 1 4 6a6 6 0 1 1 9.758 4.673C17.417 12.048 20 15.445 20 20m-7.586-5.243 1.414 1.415L10 20l-2.828-2.828 1.414-1.415L10 17.172z"
    }, null, -1)
  ])))
}
export default { render: render }